import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const configConstants = {
  GET_PRECOG_CONFIG_START: "GET_PRECOG_CONFIG_START",
  GET_PRECOG_CONFIG_SUCCESS: "GET_PRECOG_CONFIG_SUCCESS",
  GET_PRECOG_CONFIG_ERROR: "GET_PRECOG_CONFIG_ERROR"
};

export function getPrecogConfig() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      dispatch({
        type: configConstants.GET_PRECOG_CONFIG_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/config/precog?managerId=${managerId}&itemId=${itemId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: configConstants.GET_PRECOG_CONFIG_SUCCESS,
              payload: result
            });
            resolve(result);
          } else {
            dispatch({
              type: configConstants.GET_PRECOG_CONFIG_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((error) => {
          dispatch({
            type: configConstants.GET_PRECOG_CONFIG_ERROR,
            error: error
          });
          reject();
        });
    });
  };
}
